import { useId } from 'react';
import type { CustomFieldProps } from './types';
import { CustomFieldLabel } from './custom-field-label';
import { CustomFieldHelperText } from './custom-field-helper-text';
import { XIcon } from 'lucide-react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

export function CustomBooleanField({
  title,
  onValueChange,
  value,
  disabled,
  required,
  description,
  error,
  placeholder,
}: CustomFieldProps) {
  const id = useId();
  const handleClear = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    onValueChange?.('');
  };
  return (
    <div className='w-full not-first:*:mt-2'>
      <CustomFieldLabel required={required} htmlFor={id}>
        {title}
      </CustomFieldLabel>
      <div className='relative'>
        <Select value={value} onValueChange={onValueChange} disabled={disabled}>
          <SelectTrigger
            id={id}
            data-has-value={value !== ''}
            className='data-[has-value=false]:text-muted-foreground/70'
          >
            <SelectValue placeholder={placeholder || title} />
          </SelectTrigger>
          {value && !required && !disabled && (
            <button
              type='button'
              onClick={handleClear}
              className='absolute top-1/2 right-8 -translate-y-1/2 rounded-full p-1 hover:bg-accent focus:ring-2 focus:ring-ring focus:outline-hidden'
              aria-label='Clear selection'
            >
              <XIcon size={16} className='text-muted-foreground' />
            </button>
          )}
          <SelectContent>
            <SelectItem value={'true'}>Ja</SelectItem>
            <SelectItem value={'false'}>Nej</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <CustomFieldHelperText error={error} description={description} />
    </div>
  );
}
